import { render, staticRenderFns } from "./VBreadcrumbs.vue?vue&type=template&id=327d1be0&"
import script from "./VBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./VBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./VBreadcrumbs.vue?vue&type=style&index=0&id=327d1be0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports